import React from 'react';

import MedicationsTable from 'components/shared/Forms/Custom/ProviderMedications/components/MedicationsTable';
import UpsertProviderMedication from 'components/shared/Forms/Custom/ProviderMedications/components/UpsertMedication';

import { upsertMedicationsLocally } from './lib/upsertMedicationsLocally';

const Medications = ({ formik, showMedicationModal, setShowMedicationModal }) => {
  const handleReturnValues = (data) => {
    if (!data) {
      return;
    }

    upsertMedicationsLocally({
      data,
      formik
    });
    setShowMedicationModal({ open: false });
  };

  return (
    <div className="h-[400px]">
      {showMedicationModal?.open && (
        <UpsertProviderMedication
          showModal={showMedicationModal}
          hideModal={() => setShowMedicationModal({ open: false })}
          returnValues={handleReturnValues}
          isNonERXPrescription
        />
      )}

      <MedicationsTable title="Medications" data={formik.values?.medications} />
    </div>
  );
};

export default Medications;
